import { LogLevel } from "@azure/msal-browser";

const tenantId = process.env.AZ_TENANT_ID;
const clientId = process.env.AZ_CLIENT_ID;
const webURL = process.env.SD_URL;
const env = process.env.APP_ENV || "PROD";

if (!tenantId) {
  throw new Error("REACT_APP_AZ_TENANT_ID is not defined in the environment variables.");
}

if (!clientId) {
  throw new Error("REACT_APP_AZ_CLIENT_ID is not defined in the environment variables.");
}

if (!webURL) {
  throw new Error("REACT_APP_SD_URL is not defined in the environment variables.");
}

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: webURL,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    // storeAuthStateInCookie: true,
    // secureCookies: true,
  },
  system: {
    loggerOptions: {
      logLevel: env === "DEV" || env === "UAT" ? LogLevel.Info : LogLevel.Error,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(`MSAL Error: ${message}`);
            break;
          case LogLevel.Warning:
            if (env === "DEV" || env === "UAT") {
              console.warn(`MSAL Warning: ${message}`);
            }
            break;
          case LogLevel.Info:
            if (env === "DEV" || env === "UAT") {
              console.info(`MSAL Info: ${message}`);
            }
            break;
          default:
            break;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: [],
};
